export default ['sender', 'recipient', 'subject', 'message-id', 'size']
